import { LoadingSection } from "@/components/loading-section"

import { useAuth } from "../hooks/use-auth"

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isUserAuthenticated, isRedirectingToLogin } = useAuth()

  if (!isUserAuthenticated && isRedirectingToLogin) {
    return (
      <section className="flex h-screen w-screen items-center justify-center">
        <div className="flex w-full max-w-md flex-col items-center gap-4 px-4 text-center">
          <h1 className="text-xl font-semibold">Redirecting to sign-in…</h1>
          <p className="text-muted-foreground text-sm">Your session may have expired.</p>
          <div className="w-full">
            <LoadingSection />
          </div>
        </div>
      </section>
    )
  }

  if (isUserAuthenticated) {
    return children
  }

  return (
    <section className="flex h-screen w-screen items-center justify-center">
      <LoadingSection />
    </section>
  )
}
